import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { memberTheme } from "../memberTheme";
import { CssBaseline, Link, ThemeProvider, darken } from "@mui/material";

const pages = [
  { name: "Campaigns", link: "https://home.38degrees.org.uk/campaigns/" },
  { name: "Latest", link: "https://home.38degrees.org.uk/news/" },
  { name: "About", link: "https://home.38degrees.org.uk/about/" },
  { name: "Donate", link: "https://act.38degrees.org.uk/act/donate-website" },
];

function Header() {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const appBarRef = React.useRef(null);

  const startPetitionButton = (displayStyles: { xs: string; md: string }) => (
    <Button
      href="https://you.38degrees.org.uk/petition/start?source=38navbar"
      sx={{
        fontSize: "1rem",
        fontWeight: "bold",
        backgroundColor: memberTheme.palette.blue.main,
        display: displayStyles,
        ":hover": {
          backgroundColor: darken(memberTheme.palette.blue.main, 0.1),
          color: memberTheme.palette.primary.contrastText,
        },
      }}
    >
      Start A Petition
    </Button>
  );

  return (
    <Box sx={{ marginBottom: { xs: "0px", md: "10px" } }}>
      <ThemeProvider theme={memberTheme}>
        {/* Google Tag Manager (noscript) */}
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-NP7QSW4"
            title="google_tag_manager"
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          />
        </noscript>
        {/* End Google Tag Manager (noscript) */}
        <CssBaseline />
        <AppBar
          ref={appBarRef}
          position="static"
          sx={{
            bgcolor: "greys.grey100",
            boxShadow: "0 0px 0px 0px",
            height: "84px",
            display: { xs: "none", md: "block" },
          }}
        >
          <Container maxWidth="xl" sx={{ height: "100%" }}>
            <Toolbar disableGutters sx={{ height: "100%" }}>
              <Link href="https://home.38degrees.org.uk">
                <Box
                  component="img"
                  sx={{ width: "240px", paddingLeft: "50px", display: { xs: "none", md: "flex" } }}
                  src="https://home.38degrees.org.uk/wp-content/themes/38degrees89up/assets/images/38D-Logo.svg"
                  alt="38 Degrees Logo"
                />
              </Link>
              <Box
                justifyContent="flex-end"
                sx={{ flexGrow: 1, gap: "24px", display: { xs: "none", md: "flex", alignItems: "flex-end" } }}
              >
                {pages.map((page) => (
                  <Link
                    key={page.name}
                    onClick={handleCloseNavMenu}
                    underline="none"
                    sx={{
                      color: memberTheme.palette.primary.dark,
                      height: "46px",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      fontSize: "1rem",
                      display: "flex",
                      textAlign: "center",
                      alignItems: "center",
                      padding: "10px",
                    }}
                    href={page.link}
                  >
                    {page.name}
                  </Link>
                ))}
                <div></div>
              </Box>
              {startPetitionButton({ xs: "none", md: "flex" })}
            </Toolbar>
          </Container>
        </AppBar>
        <AppBar
          ref={appBarRef}
          position="static"
          sx={{
            bgcolor: "greys.grey100",
            boxShadow: "0 0px 0px 0px",
            height: "56px",
            display: { xs: "block", md: "none" },
          }}
        >
          <Container maxWidth="xl" sx={{ height: "100%" }}>
            <Toolbar disableGutters sx={{ minHeight: { xs: "56px", sm: "56px" } }}>
              <Link href="https://home.38degrees.org.uk">
                <Box
                  component="img"
                  sx={{ width: "120px", paddingLeft: "0px", display: { xs: "flex", md: "none" } }}
                  src="https://home.38degrees.org.uk/wp-content/themes/38degrees89up/assets/images/38D-Logo.svg"
                  alt="38 Degrees Logo"
                />
              </Link>
              <Box justifyContent="flex-end" sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  sx={{ color: memberTheme.palette.primary.dark }}
                >
                  {anchorElNav ? <CloseIcon /> : <MenuIcon />}
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  PaperProps={{
                    style: {
                      minHeight: `${window.innerHeight - 56}px`,
                      minWidth: "100vw",
                      backgroundColor: memberTheme.palette.primary.main,
                      borderRadius: 0,
                    },
                    sx: {
                      top: "initial !important",
                    },
                  }}
                  sx={{
                    display: { xs: "block", md: "none" },
                    top: 56,
                    left: 16,
                  }}
                >
                  {pages.map((page) => (
                    <MenuItem
                      key={page.name}
                      onClick={handleCloseNavMenu}
                      component="a"
                      href={page.link}
                      sx={{
                        justifyContent: "center",
                        ":hover": {
                          textDecoration: "none",
                          color: memberTheme.palette.primary.contrastText,
                        },
                        padding: "10px",
                      }}
                    >
                      <Typography fontSize="24px" fontWeight="bold" color="inherit" align="center">
                        {page.name}
                      </Typography>
                    </MenuItem>
                  ))}
                  <MenuItem onClick={handleCloseNavMenu} sx={{ justifyContent: "center", padding: "10px" }}>
                    {startPetitionButton({ xs: "flex", md: "none" })}
                  </MenuItem>
                </Menu>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      </ThemeProvider>
    </Box>
  );
}
export default Header;
